
import type { Commit, Dispatch } from 'vuex'
import { getMeasureNewCountApi } from '@/apis/stock'

export default {
  namespaced: true,
  state: {
    num: 0
  },
  getters: {
    getMeasureNum (state: { num: number }): number {
      return state.num
    }
  },
  mutations: {
    SET_MEASURE_NUM: (
      state: { num: number },
      num: number
    ): void => {
      state.num = num
    }
  },
  actions: {
    getMeasureNum (store: any) {
      const { commit, dispatch, state, rootState } = store
      getMeasureNewCountApi().then((res: any) => {
        if (res.success) {
          commit('SET_MEASURE_NUM', res.data)
        }
      })
    }
  }
}
